import { t } from "i18next";
import { useState } from "react";
import CoreButton from "../CoreButton/CoreButton";

const DocCompositionSettings = ({ onSend, onCancel }) => {
  const [selectedFidelity, setSelectedFidelity] = useState("");

  const fidelityLevels = [
    {
      value: "HIGH",
      title: t("FidelityHighTitle"),
      description: t("FidelityHighDescription"),
      usage: t("FidelityHighUsage"),
      behavior: t("FidelityHighBehavior"),
    },
    {
      value: "MEDIUM",
      title: t("FidelityMediumTitle"),
      description: t("FidelityMediumDescription"),
      usage: t("FidelityMediumUsage"),
      behavior: t("FidelityMediumBehavior"),
    },
    {
      value: "LOW",
      title: t("FidelityLowTitle"),
      description: t("FidelityLowDescription"),
      usage: t("FidelityLowUsage"),
      behavior: t("FidelityLowBehavior"),
    },
  ];

  const handleSend = () => {
    if (selectedFidelity) {
      onSend(selectedFidelity);
    }
  };

  return (
    <div className="p-6">
      <h3 className="text-xl font-semibold mb-6 text-center">
        {t("DocumentCompositionSettings")}
      </h3>

      <div className="mb-6">
        <div className="space-y-4">
          {fidelityLevels.map((level) => (
            <div
              key={level.value}
              className="border rounded-lg p-4 hover:bg-gray-50"
            >
              <label className="flex items-start cursor-pointer">
                <input
                  type="radio"
                  name="fidelity"
                  value={level.value}
                  checked={selectedFidelity === level.value}
                  onChange={(e) => setSelectedFidelity(e.target.value)}
                  className="mt-1 mr-3"
                />
                <div className="flex-1">
                  <div className="font-bold text-lg mb-2">{level.title}</div>
                  <div className="text-sm">
                    <div className="mb-1">
                      <strong>{t("Description")}:</strong> {level.description}
                    </div>
                    <div className="mb-1">
                      <strong>{t("TypicalUsage")}:</strong> {level.usage}
                    </div>
                    <div className="text-gray-700">
                      <strong>{t("IABehavior")}:</strong> {level.behavior}
                    </div>
                  </div>
                </div>
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-center gap-4 pt-4 border-t">
        <CoreButton
          testo={t("Cancel")}
          onClick={onCancel}
          className="btn-round secondary"
        />
        <CoreButton
          testo={t("Send")}
          onClick={handleSend}
          disabled={!selectedFidelity}
          className="btn-round"
        />
      </div>
    </div>
  );
};

export default DocCompositionSettings;
